<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        has-feedback
        :label="$t('form.article.title.label')"
        style="margin-bottom: 0px"
      >
        <a-input
          v-model="searchForm.title"
          :placeholder="$t('form.article.title.placeholder')"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">{{
          $t(`actionTitles.submit`)
        }}</a-button>
      </a-form-model-item>
      <a-form-model-item layout="vertical">
        <a-button
          type="primary"
          :style="{ margin: '0px 15px' }"
          @click="addArticle"
          >{{ $t(`actionTitles.add`) }}</a-button
        >
      </a-form-model-item>
    </a-form-model>

    <div class="table-wrapper">
      <a-table
        :data-source="pageResult"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column
          key="id"
          :title="$t('table.article.thead.id')"
          data-index="id"
          align="center"
        ></a-table-column>
        <a-table-column
          key="title"
          :title="$t('table.article.thead.name')"
          data-index="title"
          align="center"
        />
        <a-table-column
          key="cate_name"
          :title="$t('table.article.thead.type')"
          data-index="cate_name"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.cate_name ? record.cate_name : "-" }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="sort_order"
          :title="$t('table.common.thead.sort')"
          data-index="sort_order"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.sort_order }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.createTime')"
          data-index="create_time"
          align="center"
        ></a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="preview(record.id)">{{
                $t(`actionTitles.preview`)
              }}</a>
              <a-divider type="vertical" />
              <a @click.stop="editArticle(record.id)">{{
                $t(`actionTitles.edit`)
              }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => delArticle(record.id)"
              >
                <a href="javascript:;" style="color: red">{{
                  $t(`actionTitles.delete`)
                }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="saveCate"
      @cancel="close"
      keyboard
      width="50%"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item
          ref="title"
          :label="$t('form.article.title.label')"
          prop="title"
        >
          <a-input
            v-model="form.title"
            :placeholder="$t('form.article.title.placeholder')"
            @blur="
              () => {
                $refs.title.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          :label="$t('moduleTitles.ArtCateManage')"
          prop="cate_id"
        >
          <a-row>
            <a-col :span="12">
              <a-tree-select
                v-model="form.cate_id"
                :replaceFields="{
                  children: 'children',
                  title: 'name',
                  key: 'id',
                  value: 'id',
                }"
                :tree-data="treeSelectData"
                tree-default-expand-all
              ></a-tree-select>
            </a-col>
            <a-col :span="10">
              <span style="margin-left: 20px">{{
                $t("message.singlePageMessage")
              }}</span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item :label="$t('form.article.isNav.label')">
          <a-radio-group
            v-model="form.is_nav"
            name="radioGroup"
            :default-value="0"
          >
            <a-radio value="0">
              {{ $t("actionTitles.no") }}
            </a-radio>
            <a-radio value="1">
              {{ $t("actionTitles.yes") }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('form.article.keywords.label')">
          <a-input
            v-model="form.keywords"
            :placeholder="$t('form.article.keywords.placeholder')"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('table.common.thead.sort')">
          <a-input-number
            v-model="form.sort_order"
            :min="0"
            :placeholder="$t('message.sortTip')"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('enum.covers.1')">
          <div style="height: 100%">
            <div style="margin-bottom: 5px; width: 50%" v-if="form.poster">
              <img :src="form.poster" width="100%" height="100%" alt="poster" />
            </div>
            <DragUploader
              ref="uploader"
              uptype="artPoster"
              :callback="getUploader"
            >
              <a-button type="primary" slot="body">{{
                $t("message.uploadBtn")
              }}</a-button>
            </DragUploader>
          </div>
        </a-form-model-item>
        <a-form-model-item :label="$t('form.article.content.label')">
          <editor :value="form.content" @changeEditor="changeEditor"></editor>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import {
  pageQuery,
  save,
  deleteInfo,
  detail,
  getArtCateTree,
} from "@/api/article";
import Editor from "@/components/Editor";
import DragUploader from "@/components/DragUploader";
const defaultArticleForm = {
  title: "",
  cate_id: 0,
  cate_name: "",
  keywords: "",
  content: "",
  sort_order: 99,
  poster: "",
  is_nav: "0",
};
export default {
  components: {
    DragUploader,
    Editor,
  },
  data() {
    return {
      searchForm: {
        current_page: 1,
        per_page: 10,
        title: "",
        order: {},
      },
      pageResult: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      modelTitle: "",
      form: {
        title: "",
        cate_id: 0,
        cate_name: "",
        keywords: "",
        content: "",
        sort_order: 99,
        poster: "",
        is_nav: "0",
      },
      exitVisible: false,
      rules: {
        title: [
          {
            required: true,
            message: this.$t("form.article.title.placeholder"),
            trigger: "blur",
          },
        ],
        cate_id: [
          {
            required: true,
            message: this.$t("form.article.type.placeholder"),
            trigger: "blur",
          },
        ],
      },
      articleCateTree: [],
    };
  },
  mounted() {
    this.loadData();
    getArtCateTree()
      .then((res) => {
        if (res.code === 1) {
          this.articleCateTree = res.data;
        }
      })
      .catch(() => {
        this.loading = false;
      });
  },
  computed: {
    treeSelectData() {
      let children = [];
      this.articleCateTree.forEach((item) => {
        if (item.hasOwnProperty("children")) {
          item = { ...item };
          item.children = null;
        }
        children.push(item);
      });
      return [
        {
          id: 0,
          name: this.$t("form.article.type.defaultName"),
          children: this.articleCateTree,
        },
      ];
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQuery(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.pageResult = res.data.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
    },

    handleReset() {
      this.form = { ...defaultArticleForm };
    },
    close() {
      this.exitVisible = false;
      this.$refs.form.resetFields();
    },
    saveCate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          save(this.form)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success(this.$t("message.saveSuccess"), 2, () => {
                  this.exitVisible = false;
                  this.loadData();
                });
              }
            })
            .catch((err) => {});
        }
      });
    },
    editArticle(id) {
      this.modelTitle = this.$t("form.article.modify.title");
      detail({ id }).then((res) => {
        this.exitVisible = true;
        this.$nextTick(() => {
          this.handleReset();
          this.form = res.data;
        });
      });
    },
    preview(id) {
      const { href } = this.$router.resolve({
        path: "/new/" + id,
      });
      window.open(href, "_blank");
    },
    delArticle(id) {
      deleteInfo({ id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
            });
          }
        })
        .catch((err) => {});
    },

    addArticle() {
      this.modelTitle = this.$t("form.article.add.title");
      this.exitVisible = true;
      this.$nextTick(() => {
        this.handleReset();
      });
    },
    changeEditor(content) {
      this.form.content = content;
    },
    //回調方法，up為上傳實例對像
    getUploader(up) {
      this.$nextTick(() => {
        up.bind("UploadComplete", (up, file) => {
          this.form.poster = this.$refs.uploader.fileList[0].url;
          this.$forceUpdate();
        });
      });
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .ant-modal-footer {
  margin-top: 80px !important;
}
.ant-input-number {
  width: 100%;
}
</style>
